import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import Icon from '@common/images/correct-icon.svg';

export function IconCorrect(props) {
  return <Image className={props.className} src={Icon} alt='IconCorrect' />;
}

IconCorrect.propTypes = {
  className: PropTypes.string,
};

IconCorrect.defaultProps = {
  className: '',
};
